
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { CustomAlertService } from "../../common/service/custom-alert.service";
import { PermissoesUsuario } from "../../common/model/permissoes-usuario";
import { PermissaoDefault } from "../../common/model/permissao-default";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { ConfiguracaoService } from "../../common/service/configuracao.service";
import {mostrarSenha} from "../../common/utils/validacaoSenha";
import { WINDOW } from "../../../common/providers/window.provider";
import { Injectable, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LanguageService } from "../../common/service/language.service";
import { StorageProxy } from "../../common/service/storage-proxy.service";
import { Lista } from "../../common/model/lista";
import { ElasticsearchEditComponent } from "../../elasticsearch/elasticsearch-edit/elasticsearch-edit.component";
import { ElasticsearchEditFormComponent } from "../../elasticsearch/elasticsearch-edit/elasticsearch-edit-form/elasticsearch-edit-form.component";
import { Template } from "../../common/model/template";
import { ListaFormCadastroService } from "../../common/service/lista-form-cadastro.service";
import { isNull, isNullOrEmpty } from "../../common/utils";
import { ListaTemplateItem } from "../../common/model/lista-template-item";

@Component({
	selector: "app-lista-cadastro-registro",
	templateUrl: "./lista-cadastro-registro.component.html",
	styleUrls: ["./lista-cadastro-registro.component.scss"],
	standalone: true,
	imports: [RouterModule, MatDialogModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatIconModule, MatCardModule, MatSelectModule, FormsModule, CommonModule, TranslatePipe, ElasticsearchEditFormComponent],
	providers: [
		{ useClass: CustomAlertService, provide: CustomAlertService },
		{ useClass: ConfiguracaoService, provide: ConfiguracaoService },
		{ useClass: ListaFormCadastroService, provide: ListaFormCadastroService}
	]
})
export class ListaCadastroRegistroComponent implements OnInit {
	public AppConfig: any;
	lista: any;
	dados:any;
	listaId:number;
	template: Template;
	idiomaSelecionado;
	idiomas;
	token:string;
	erro:string | null = null;
	loadCompleto:boolean = false;
	cadastroIntegracao:boolean = true;
	isEdit:boolean = false;
	cadastroAtivo = false;
	logo: string = 'talkmaestria';

	constructor(
		private customAlertService: CustomAlertService,
		private configService: ConfiguracaoService,
		private listaIntegracaoCadastroService: ListaFormCadastroService,
		private router: Router,
    public dialog: MatDialog,
		private route: ActivatedRoute,
		private languageService: LanguageService,
		@Inject(WINDOW) private window: Window
	) {

		this.idiomas = this.languageService.idiomas;
		this.idiomaSelecionado = this.languageService.getLanguage();
		
		this.lista = new Lista();
		this.template = new Template();
		this.template.listaTemplateItem = new Array<ListaTemplateItem>();
		this.listaId = 0;
		this.loadCompleto = false;
		this.dados = {}
		this.cadastroIntegracao = true;
		this.isEdit = false;
		this.cadastroAtivo = false;
	}

	ngOnInit(): void {
		this.AppConfig = environment;

		this.route.queryParams.subscribe(parametros =>{
			this.token = parametros['token'];

			if (!isNull(this.token))
			{

				this.listaIntegracaoCadastroService.ValidarToken(this.token).subscribe(
					
					(lista) => {
						if (isNullOrEmpty(lista))
						{
							this.erro =  "autenticacao.erroToken"
						}
						else
						{
							this.lista = lista;
							this.template = lista.listaTemplate;
							this.listaId = this.lista.listaId;
							this.cadastroAtivo = true;
						}
						this.loadCompleto = true;
					},
					(error) => {
							this.erro = error.error.message;
							this.loadCompleto = true;
					}
				  );

			}
			else{
				this.erro = "autenticacao.erroToken";
				this.loadCompleto = true;
			}
		})
	}
	
	setLanguage(linguagem: any) {
		this.languageService.setLanguage(linguagem.codigo);
		this.idiomaSelecionado = linguagem;
		window.location.reload();
	}

	fechar(s: any = null) {
		this.cadastroAtivo = false;
		if (s) {
			if (s.isError)
				this.customAlertService.show("telaPadrao.erro", "telaPadrao.inclusaoErro", "error");
			else {
				
			}
		}
	}
	
}
